// @flow
export const BingeWatchingEvent = {
  BINGE_WATCHING_PLAY_NEXT_SELECTED: 'BW Play Next',
  BINGE_WATCHING_CANCEL_SELECTED: 'BW Cancel',
  BINGE_WATCHING_NO_USER_ACTION: 'BW No User Action',
  NUMBER_OF_CONTINUOUS_EPISODES_WATCHED: 'BW Cont Episodes Watched',
};

export type Action =
  | {|
      type: 'ANALYTICS_BINGE_WATCHING_PLAY_NEXT_OR_CANCEL_SELECTED',
      isCanceled: boolean,
      franchiseName: string,
      episodeName: string,
      seasonNumber: string,
      episodeNumber: string,
      timeLeft: number,
    |}
  | {|
      type: 'ANALYTICS_BINGE_WATCHING_NO_USER_ACTION',
      franchiseName: string,
      episodeName: string,
      seasonNumber: string,
      episodeNumber: string,
    |}
  | {|
      type: 'ANALYTICS_NUMBER_OF_CONTINUOUS_EPISODES_WATCHED',
      networkName: string,
      eventName: string,
      count: number,
    |};
